module.exports = __webpack_public_path__ + "img/林靜儀.0e74145b.png";